import React, { useState, useEffect } from "react";
import { json, NavLink, useNavigate, useParams } from "react-router-dom";
import SelectLocation from "../Map/SelectLocation";
import Congratulation from "../Popup/Congratulation";
import TermsPopup from "../Popup/TermsPopup";
import { doRequest, produrl, textMapping } from "../utils/helper";
import Select from "react-select";
import ErrorPopup from "../Popup/ErrorPopup";
import $ from "jquery";
import Loader from "../Popup/Loader";
import Calendar from "../Login/Calendar";
import moment from "moment";
import CalendarDrop from "./CalendarDrop";
import InfoPopup from "../Popup/InfoPopup";
const CryptoJS = require("crypto-js");
const errorStyle = {
  color: "red",
};

const UserDetail = ({ setProfileimage, editdata }) => {
  const { refnum } = useParams();
  const [emailCheckError, setEmailcheckError] = useState(false);
  const [nameCheckError, setNamecheckError] = useState(false);
  const [mobileCheckError, setMobileCheckError] = useState(false);
  const [doberror, setDoberror] = useState(false);
  const [maxDate, setMaxDate] = useState("");
  const [pincodeError, setPincodeError] = useState(false);
  const [thankupopup, setThankuPopup] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [stateval, setStateVal] = useState([]);
  const [cityval, setCityVal] = useState([]);
  const [constval, setConstVal] = useState([]);
  const [filterstateval, setFilterstateval] = useState([]);
  const [options, setOption] = useState([]);
  const [filterid, getFilterid] = useState("");
  const [refError, setRefError] = useState(false);
  const [filterdistrictval, setFilterdistrictval] = useState([]);
  const [filterassemblyval, setFilterassemblyNamesval] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [errorpopup, setErrorpopup] = useState(false);
  const [infopopup, setInfopopup] = useState(false);
  const [message, setMessage] = useState("");
  const [useredit, setUseredit] = useState("");
  const [reff, setReff] = useState("");
  const [refstatus, setrefstatus] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    date_of_birth: "",
    age: "",
    gender: "Male",
    salutation: "Mr.",
    email: "",
    address: "",
    pin_code: "",
    state: "",
    referral: "",
    member_id: "",
    district: "",
    assembly_constituency_id: "",
    referred_by_number: "",
    referred_by_name: "",
    referred_by_hash: "",
    access_token: localStorage.getItem("acesss"),
    refresh_token: localStorage.getItem("refresh"),
    user_id: localStorage.getItem("userid"),
  });

  const [filteredStateList, setFilteredStateList] = useState([]);
  const [filteredDisttList, setFilteredDisttList] = useState([]);
  const [filteredConstiList, setFilteredConstiList] = useState([]);
  const [pincodeState, setPincodeState] = useState([]);
  const [pincodeDistt, setPincodeDistt] = useState([]);
  const [pincodeConsti, setPincodeConsti] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (editdata && Object.keys(editdata).length > 0) {
      // console.log("editdata", editdata);
      let formattedDate = moment(editdata.date_of_birth).format("DD-MM-YYYY");
      setFormData({
        ...formData,
        name: editdata.name || "",
        mobile_number: editdata.mobile_number || "",
        date_of_birth: formattedDate || "",
        email: editdata.email || "",
        state_id: editdata.state_id || "",
        district: editdata.district || "",
        assembly_constituency_id: editdata.assembly_constituency_id || "",
        gender: editdata.gender || "",
        salutation: editdata.salutation || "",
        pin_code: editdata.pin_code || "",
        address: editdata.address || "",
      });
      callEdithandle(editdata.pin_code, editdata.state_id, editdata.district);
      // if (editdata.pin_code) {
      //   getPincode(editdata.pin_code);
      //    getDistrictList(editdata.state_id);
      //    getConstList(editdata.state_id);
      // } else {
      //   getDistrictList(editdata.state_id);
      //   getConstList(editdata.state_id);
      // }
    }
  }, [editdata]);

  const callEdithandle = async (pincode, stateid, district) => {
    // if (pincode) {
    await getDistrictList(stateid);
    await getConstList(district);
    // await getPincode(pincode);
    await getStateList();
    // } else {
    //   await getDistrictList(stateid);
    //   await getConstList(stateid);
    //   await getStateList();
    // }
  };

  useEffect(() => {
    const number = localStorage.getItem("num");
    setFormData((prevData) => ({
      ...prevData,
      mobile_number: number,
    }));
  }, [localStorage.getItem("num")]);

  useEffect(() => {
    if (refnum) {
      handleReferal(refnum);
    }
  }, [refnum]);

  const handleReferal = async (value) => {
    const number = refnum ? refnum : value;
    if (!number || number == "") {
      return;
    }
    const url = `${produrl}api/v1/pm/validate_referral`;
    let obj = {
      phone_number: number.toUpperCase(),
    };
    const options = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
      body: JSON.stringify(obj),
      // body: `{"phone_number": ${number}}`,
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status === 200) {
        setInfopopup(false);
        setErrorpopup(false);
        setFormData((prevData) => ({
          ...prevData,
          referred_by_name: data.data.referred_by_name,
          referred_by_hash: data.data.referred_by_hash,
          referred_by_number: number,
        }));
        setReff(number);
        // setrefstatus(false);
      } else if (response.status == 410) {
        setInfopopup(true);
        setErrorpopup(false);
        setMessage(data?.error);
      } else {
        setErrorpopup(true);
        setInfopopup(false);

        // setrefstatus(true);
        setFormData((prevData) => ({
          ...prevData,
          referred_by_name: "",
          // referred_by_number: "",
          referred_by_hash: "",
        }));
        // setMessage(
        //   number.toUpperCase() +
        //     textMapping(
        //       ": is not a Primary Member, Only Primary Members can refer"
        //     )
        // );
        setMessage(data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  // const decryptData = (encryptedData, secretKey) => {
  //   try {
  //     if (!encryptedData) return null;
  //     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  //     const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  //     return decryptedData ? JSON.parse(decryptedData) : null;
  //   } catch (error) {
  //     console.error("Error during decryption or parsing:", error);
  //     return null;
  //   }
  // };
  const formatDateForInput = (dateString) => {
    const [day, monthName, year] = dateString.split("-");

    const months = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };

    const month = months[monthName.toLowerCase()] || "01";

    return `${year}-${month}-${day}`;
  };

  // useEffect(() => {
  //   const secretKey = "2ca6f23d8cc3e1e1";
  //   const encryptedData = localStorage.getItem("user");
  //   const decryptedData = decryptData(encryptedData, secretKey);
  //   if (decryptedData) {
  //     const numberval = decryptedData["number"] || "";
  //     const formattedNumber = numberval.startsWith("+91")
  //       ? numberval.replace(/^\+91\s*/, "")
  //       : numberval;

  //     const gender = decryptedData["gender"]
  //       ? decryptedData["gender"].toLowerCase()
  //       : "female";
  //     const salutation = gender === "male" ? "Mr." : "Mrs.";
  //     const formattedDateForInput = decryptedData["dob"]
  //       ? formatDateForInput(decryptedData["dob"])
  //       : "";
  //     setFormData({
  //       ...formData,
  //       name: decryptedData["name"] || "",
  //       mobile_number: localStorage.getItem("num"),
  //       date_of_birth: formattedDateForInput,
  //       email: decryptedData["useremail"] || "",
  //       state_id: decryptedData["statename"] || "",
  //       district: decryptedData["district_name"] || "",
  //       assembly_constituency_id: decryptedData["constituency_name"] || "",
  //       gender: gender.charAt(0).toUpperCase() + gender.slice(1),
  //       salutation: salutation,
  //     });
  //   } else {
  //     const localnum = localStorage.getItem("num");
  //     setFormData({
  //       ...formData,
  //       name: "",
  //       mobile_number: localnum,
  //       date_of_birth: "",
  //       email: "",
  //       state_id: "",
  //       district: "",
  //       assembly_constituency_id: "",
  //       gender: "Male",
  //       salutation: "",
  //     });
  //   }
  //   getStateList();
  // }, []);

  useEffect(() => {
    const useredit = localStorage.getItem("useredit");
    setUseredit(useredit);

    getStateList();
  }, []);

  const getPincode = async (pincode) => {
    if (pincode.length < 6) {
      return;
    }
    const url = `${produrl}api/v1/metadata/pin_code_details?pin_code=${pincode}`;
    const form = new FormData();

    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status === 200) {
        if (data.length > 0) {
          const stateNames = data.map((item) => item.state);
          setPincodeState(stateNames);
          const districtNames = data.map((item) => item.district);
          setPincodeDistt(districtNames);
          // const AssemblyNames = data.map((item) => item.ac_number);
          // setPincodeConsti(AssemblyNames);

          let selectedStateAry = stateval.filter(
            (list) => stateNames.indexOf(list.name) != -1
          );
          if (stateNames.length > 0) {
            // let filter = [];
            // for (let i = 0; i < stateval.length; i++) {
            //   for (let j = 0; j < stateNames.length; j++) {
            //     if (stateval[i].name === stateNames[j]) {
            //       if (!filter.includes(stateval[i])) {
            //         filter.push(stateval[i]);
            //       }
            //     }
            //   }
            // }
            // setFilteredStateList(filter);
            let stateid = selectedStateAry[0].id;
            getFilterid(stateid);

            // let list = [];
            // let distlist = await getDistrictList(stateid);
            // for (let i = 0; i < distlist.length; i++) {
            //   for (let j = 0; j < districtNames.length; j++) {
            //     if (distlist[i].name === districtNames[j]) {
            //       if (!list.includes(distlist[i])) {
            //         list.push(distlist[i]);
            //       }
            //     }
            //   }
            // }
            // setFilteredDisttList(list);
            let distlist = await getDistrictList(stateid);
            setCityVal(distlist);
            let selectedDistAry = distlist.filter(
              (list) => districtNames.indexOf(list.name) != -1
            );
            let aclist = await getConstList(stateid);
            setConstVal(aclist);

            // let selectedAssAry = aclist.filter(
            //   (list) => AssemblyNames.indexOf(list.number) != -1
            // );
            // let arr = [];
            // for (let i = 0; i < aclist.length; i++) {
            //   for (let j = 0; j < AssemblyNames.length; j++) {
            //     if (aclist[i].number === AssemblyNames[j]) {
            //       if (!arr.includes(aclist[i])) {
            //         arr.push(aclist[i]);
            //       }
            //     }
            //   }
            // }
            // setFilteredConstiList(arr);

            // let obj = { ...formData };
            // if (arr && arr.length > 0) {
            //   obj["assembly_constituency_id"] = arr[0].id;
            // } else {
            //   obj["assembly_constituency_id"] = "";
            // }
            // if (list && list.length > 0) {
            //   obj["district"] = list[0].id;
            // } else {
            //   obj["district"] = "";
            // }
            setFormData((prevData) => ({
              ...prevData,
              state_id: stateid,
              district: selectedDistAry[0].id,
              // assembly_constituency_id: selectedAssAry[0].id,
            }));
          } else {
            setFilteredStateList(stateval);
            setFilteredDisttList([]);
            setFilteredConstiList([]);

            setFormData((prevData) => ({
              ...prevData,
              district: "",
              assembly_constituency_id: "",
              state_id: "",
            }));
          }
        } else {
          setFilteredStateList(stateval);
        }
      } else {
        // setErrorpopup(true);
        setMessage(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getStateList = async () => {
    const url = `${produrl}api/v1/metadata/all`;
    const form = new FormData();

    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status == 200) {
        if (data.states) {
          const sortedStates = data.states.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          setStateVal(sortedStates);
          setFilteredStateList(sortedStates);
        }
      } else {
        setErrorpopup(true);
        setMessage(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getDistrictList = async (stateid) => {
    const url = `${produrl}api/v1/metadata/districts?state_id=${stateid}`;
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status == 200) {
        const sortedConstituencies = data.districts.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        setCityVal(sortedConstituencies);
        setFilteredDisttList(sortedConstituencies);
        return sortedConstituencies;
      } else {
        setCityVal([]);
        setFilteredDisttList([]);
        setErrorpopup(true);
        setMessage(data.message);
        return [];
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getConstList = async (district_id) => {
    const url = `${produrl}api/v1/metadata/assembly_constituencies?district_id=${district_id}`;
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status == 200) {
        const sortedConstituencies = data.assembly_constituencies.sort(
          (a, b) => {
            return a.name.localeCompare(b.name);
          }
        );
        let option = [];

        sortedConstituencies.map((consti) => {
          option.push({
            value: consti.id,
            label: `${consti.name} - ${consti.number}`,
            "data-name": consti.name,
            nameval: consti.name,
          });
        });
        setConstVal(sortedConstituencies);
        setOption(option);
        setFilteredConstiList(sortedConstituencies);
        return sortedConstituencies;
      } else {
        setConstVal([]);
        setFilteredConstiList([]);
        setErrorpopup(true);
        setMessage(data.message);
        return [];
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      salutation: prevData.gender === "Male" ? "Mr." : "Mrs.",
    }));
    if (formData.date_of_birth) {
      const [day, month, year] = formData.date_of_birth.split("-");
      const dobDate = new Date(year, month - 1, day);
      const today = new Date();

      let age = today.getFullYear() - dobDate.getFullYear();
      const hasHadBirthdayThisYear =
        today.getMonth() > dobDate.getMonth() ||
        (today.getMonth() === dobDate.getMonth() &&
          today.getDate() >= dobDate.getDate());

      if (!hasHadBirthdayThisYear) {
        age -= 1;
      }

      setFormData((prevData) => ({
        ...prevData,
        age: age + " Y",
      }));
    }
  }, [formData.date_of_birth]);

  // useEffect(() => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     salutation: prevData.gender === "Male" ? "Mr." : "Mrs.",
  //   }));
  //   if (formData.date_of_birth) {
  //     console.log(
  //       formData.date_of_birth,
  //       "formData.date_of_birthformData.date_of_birthformData.date_of_birth"
  //     );
  //     const [day, month, year] = formData.date_of_birth.split("-");
  //     const dobDate = new Date(year, month - 1, day); // month is 0-indexed in JavaScript Date
  //     // setErrorpopup(true);
  //     const currentYear = new Date().getFullYear();
  //     const dobYear = dobDate.getFullYear();
  //     const calculatedAge = currentYear - dobYear;
  //     // setMessage(dobDate+'  '+calculatedAge);
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       age: calculatedAge + " Y",
  //     }));
  //   }
  //   // console.log(
  //   //   formData.date_of_birth,
  //   //   "formData.date_of_birthformData.date_of_birth"
  //   // );
  //   // }, [formData.gender, formData.date_of_birth]);
  // }, [formData.date_of_birth]);

  useEffect(() => {
    if (message === "Unauthorized") {
      RefreshToken();
    }
  });

  const RefreshToken = async () => {
    const url = `${produrl}api/v1/token/refresh`;
    const form = new FormData();
    form.append("refresh_token", localStorage.getItem("refresh"));

    const options = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    options.body = form;

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status == 200) {
        localStorage.setItem("acesss", data.token.access_token);
        localStorage.setItem("refresh", data.token.refresh_token);
      } else {
        setErrorpopup(true);
        setMessage(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const referralvalid = () => {
    const refval = formData.referred_by_number;
    if (refval && refval?.length != 6 && refval?.length != 10) {
      setMobileCheckError(true);
    } else {
      handleReferal(refval);
      setMobileCheckError(false);
    }
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [id]: value,
    // }));
    // if (id === "pin_code" && value.length === 6) {
    //   getPincode(value);
    // }
    if (id === "district") {
      getConstList(value);
    }
    if (id === "pin_code") {
      if (!value || value === "") {
        setFormData((prevData) => ({
          ...prevData,
          state_id: "",
          district: "",
          assembly_constituency_id: "",
        }));
        setFilteredStateList(() => stateval);
        setFilteredDisttList(() => []);
        setFilteredConstiList(() => []);
      }
      // setFormData((prevData) => ({
      //   ...prevData,
      //   [id]: value,
      // }));
      if (value.length < 7) {
        setFormData((prevData) => ({
          ...prevData,
          [id]: value,
        }));
        getPincode(value);
        if (value && value?.length != 6) {
          setPincodeError(true);
        } else {
          setPincodeError(false);
        }
      }
    }

    if (id === "referred_by_number") {
      // let regex = /^-?\d*\.?\d*$/;
      let regex = /^[a-zA-Z0-9]*$/;
      if (regex.test(value)) {
        if (value.length < 11) {
          setFormData((prevData) => ({
            ...prevData,
            [id]: value,
          }));

          // if (value && value?.length != 6 && value?.length != 10) {
          //   setMobileCheckError(true);
          //   // setFormData((prevData) => ({
          //   //   ...prevData,
          //   //   referred_by_name: "",
          //   // }));
          // } else {
          //   handleReferal(value);
          //   setMobileCheckError(false);
          // }
        }
      }
    }

    if (
      id === "email" ||
      id === "name" ||
      id === "date_of_birth" ||
      id === "address" ||
      id === "referred_by_name" ||
      id === "district" ||
      id === "assembly_constituency_id" ||
      id === "salutation"
    ) {
      setFormData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    }
  };

  const handleKeyDown = (e) => {
    // Prevent non-numeric keys and multiple decimals, multiple dashes, or 'e'/'E'
    let value = e.target.value;
    if (
      ["e", "E", "+", "-", "."].includes(e.key) ||
      (e.key === "." && value.includes(".")) ||
      (e.key === "-" && value.includes("-")) ||
      (e.key === "-" && e.target.selectionStart !== 0) || // Only allow '-' at the start
      e.key === "e" ||
      e.key === "E"
    ) {
      e.preventDefault();
    }
  };
  const validateEmail = (email) => {
    const regexp = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$/;
    // const regexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regexp.test(email);
  };

  const validateName = (name) => {
    // const regexp = /^[A-Za-z\s]+$/;
    const regexp = /[0-9]/g;
    return !regexp.test(name);
  };

  const isformvalid = (formData) => {
    const {
      name,
      gender,
      pin_code,
      state_id,
      date_of_birth,
      district,
      assembly_constituency_id,
      salutation,
    } = formData;
    let err = 0;
    if (!name || name == "") {
      err += 1;
    }
    if (name && !validateName(name)) {
      setNamecheckError(true);
      err += 1;
    } else {
      setNamecheckError(false);
    }
    if (!gender || gender == "") {
      err += 1;
    }
    // if (!pin_code || pin_code == "") {
    //   err += 1;
    // }
    if (pin_code && pin_code.length != 6) {
      err += 1;
    }
    if (!state_id || state_id == "") {
      err += 1;
    }
    if (!date_of_birth || date_of_birth == "") {
      err += 1;
    }
    if (!district || district == "") {
      err += 1;
    }
    if (!assembly_constituency_id || assembly_constituency_id == "") {
      err += 1;
    }

    // if (!salutation || salutation == "") {
    //   err += 1;
    // }
    // if (
    //   formData.referred_by_number &&
    //   formData.referred_by_number.length != 10
    // ) {
    //   err += 1;
    // }
    if (!validateEmail(formData.email)) {
      setEmailcheckError(true);
      err += 1;
    } else {
      setEmailcheckError(false);
    }
    if (err > 0) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    const formisvalid = isformvalid(formData);
    setIsButtonEnabled(formisvalid);
  }, [formData]);

  const handleSave = (e) => {
    e.preventDefault(); // Prevent default form submission
    setLoading(true);
    if (isChecked) {
      setIsClicked(true);
      setShowPopup(false);
      thirdData();
    } else {
      setShowPopup(true);
      // setTimeout(() => {
      //   setShowPopup(false);
      // }, 3000);
      setLoading(false);
    }
  };

  const termclose = () => {
    setShowPopup(false);
  };

  const saveData = (memberid) => {
    setLoading(false);
    var postData = {};
    postData["action"] = "save-membership-data";
    formData["member_id"] = memberid;
    postData["data"] = formData;
    var request = doRequest(postData, true);
    request.addEventListener("load", function () {
      let response = JSON.parse(this.responseText);
      if (response._resultflag && response.id) {
      }
    });
  };
  const thirdData = async () => {
    setLoading(true);
    var element = $("#district").find("option:selected");
    var disTag = element.attr("data-name");
    var payvalue = {
      name: formData.name,
      mobile_number: formData.mobile_number,
      date_of_birth: formData.date_of_birth,
      gender: formData.gender,
      salutation: formData.salutation,
      email: formData.email,
      address: formData.address,
      pin_code: formData.pin_code,
      state_id: formData.state_id,
      member_id: "",
      referred_by_name: formData.referred_by_name,
      referred_by_number: formData.referred_by_number
        ? formData.referred_by_number.toUpperCase()
        : "",
      referred_by_hash: formData.referred_by_hash,
      // district: formData.disTag,
      // district: disTag,
      district_id: formData.district,
      assembly_constituency_id: formData.assembly_constituency_id,
    };
    if (setProfileimage) {
      payvalue["photo"] = setProfileimage;
    }

    // console.log(payvalue, "payvalue");

    // return false;
    const url = `${produrl}api/v1/pm/update`;
    const options = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },

      body: JSON.stringify(payvalue),
    };
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (response.status == 200) {
        try {
          let obj = {};
          window.gtag("event", `Submit Successfully`, obj);
        } catch (error) {}
        if (data) {
          localStorage.setItem("mem_id", data.data.membership_id);
          localStorage.setItem("name", data.data.name);
          localStorage.setItem(
            "userinfo",
            JSON.stringify({
              name: formData.name,
              mobile_number: formData.mobile_number,
              date_of_birth: formData.date_of_birth,
              gender: formData.gender,
              salutation: formData.salutation,
              email: formData.email,
              address: formData.address,
              pin_code: formData.address,
              state: formData.state_id,
              member_id: data.data.membership_id,
              district: formData.district,
              assembly_constituency_id: formData.assembly_constituency_id,
              photo: localStorage.getItem("profile")
                ? localStorage.getItem("profile")
                : setProfileimage,
            })
          );
          setLoading(false);
          setThankuPopup(true);
          setTimeout(() => {
            setThankuPopup(false);
            localStorage.removeItem("useredit");
            navigate("/refer" + window.location.search);
          }, 5000);
          saveData(data.data.membership_id);
        }
      } else if (response.status == 502) {
        setLoading(false);
        setErrorpopup(true);
        setMessage("502:Server Error");
      } else {
        setLoading(false);
        setErrorpopup(true);
        setMessage(data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const popupclose = () => {
    setErrorpopup(false);
  };
  const Infopopupclose = () => {
    setInfopopup(false);
  };

  const handleStateChange = async (e) => {
    const selectedState = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      state_id: selectedState,
      district: "",
      assembly_constituency_id: "",
    }));
    if (!selectedState || selectedState == "") {
      return;
    }

    var element = $("#state_id").find("option:selected");
    var myTag = element.attr("data-name");
    localStorage.setItem("state_name", myTag);

    if (selectedState) {
      setLoading(true);
      await getDistrictList(selectedState);
      // await getConstList(selectedState);
      setLoading(false);
    } else {
      setCityVal([]);
      setConstVal([]);
    }
  };

  const handleSalutationChange = (e) => {
    const newSalutation = e.target.value;
    let newGender = "Female"; // Default gender for salutation

    if (newSalutation === "Mr.") {
      newGender = "Male";
    } else if (newSalutation === "Miss." || newSalutation === "Mrs.") {
      newGender = "Female";
    }

    setFormData((prevData) => ({
      ...prevData,
      salutation: newSalutation,
      gender: newGender,
    }));
  };

  useEffect(() => {
    const today = new Date();
    const maxiDate = new Date(today);
    maxiDate.setFullYear(today.getFullYear() - 18);

    const formattedDate = maxiDate.toISOString().split("T")[0];
    // const maxYear = today.getFullYear() - 18;
    // const maxDate = `${maxYear}-12-31`;
    setMaxDate(formattedDate);
  }, []);
  // console.log(formData, "formDataformData");

  return (
    <>
      {loading && <Loader />}
      {/* <ErrorPopup /> */}
      <div className="form_margin">
        <div className="member_container">
          <div className="form-floating form_brd mb-3">
            <input
              type="number"
              className="form-control input_num"
              id="mobile_number"
              placeholder={textMapping("Mobile number")}
              value={formData.mobile_number}
              onChange={handleChange}
              readOnly
            />
            <label htmlFor="mobile_number" className="mobile_label">
              {textMapping("Mobile number")}
            </label>
          </div>

          <div className="username_formbg">
            <div className="selectgend_arrow">
              <select
                className="gender_select"
                id="salutation"
                value={formData.salutation}
                // onChange={handleSalutationChange}
                disabled={useredit ? true : false}
                onChange={(e) => {
                  const newSalutation = e.target.value;
                  setFormData((prevData) => ({
                    ...prevData,
                    salutation: newSalutation,
                    gender: newSalutation === "Mr." ? "Male" : "Female",
                  }));
                }}
              >
                <option value="">{textMapping("Title*")}</option>
                <option value="Mrs.">{textMapping("Mrs.")}</option>
                <option value="Mr.">{textMapping("Mr.")}</option>
                <option value="Miss.">{textMapping("Miss")}</option>
              </select>
              <img src="/assets/images/arrowdown.png" alt="" />
            </div>
            <input
              type="text"
              className="form-control userfullname"
              id="name"
              placeholder={textMapping("Full Name*")}
              value={formData.name}
              onChange={handleChange}
              readOnly={useredit ? true : false}
            />
          </div>
          {nameCheckError && (
            <p style={errorStyle}>
              {textMapping("Please enter a valid name.")}
            </p>
          )}
          <div className="form_brd">
            <div className="row">
              <div className="col-7">
                <div className="user_dob mb-3">
                  <label className="mobile_label mobile_label_new mad_col">
                    {textMapping("D.O.B")}*
                  </label>

                  <Calendar
                    setFormData={setFormData}
                    selectedDate2={formData.date_of_birth}
                    disabled={useredit ? true : false}
                  />

                  {/* <CalendarDrop /> */}
                  {/* <input
                    type="text"
                    value={formData.date_of_birth || ""}
                    disabled={useredit ? true : false}
                    placeholder="DD-MM-YYYY"
                    className="form-control input_date_dob"
                    maxLength="10"
                    onChange={(e) => {
                      let input = e.target.value.replace(/\D/g, "");
                      if (input.length > 8) input = input.slice(0, 8);
                      
                      let formattedDate = input;
                      if (input.length > 4) {
                        formattedDate = input.replace(/(\d{2})(\d{2})(\d{4})/, "$1-$2-$3");
                      }else if (input.length > 3) {
                        formattedDate = input.replace(/(\d{2})(\d{2})/, "$1-$2-");
                      } else if (input.length > 2) {
                        formattedDate = input.replace(/(\d{2})(\d{2})/, "$1-$2");
                      }

                      // Update the input value with the formatted date
                      e.target.value = formattedDate;

                      // Validate date
                      const [day, month, year] = formattedDate.split("-");
                      const inputDate = new Date(year, month - 1, day);
                      const minDate = new Date("1920-01-01");
                      const maxDate = new Date();
                      maxDate.setFullYear(maxDate.getFullYear() - 18);

                      if (inputDate < minDate || inputDate > maxDate) {
                        setDoberror(true);
                      } else {
                        setDoberror(false);
                      }

                      setFormData((prevData) => ({
                        ...prevData,
                        date_of_birth: formattedDate,
                      }));
                    }}
                  /> */}
                  {/* <input
                    type="date"
                    className="form-control input_date_dob"
                    id="floatingDate"
                    placeholder="Mobile Number"
                    disabled={useredit ? true : false}
                    min="1920-01-01"
                    max={maxDate}
                    value={formData.date_of_birth}
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      const selectedYear = selectedDate.getFullYear();
                      if (selectedYear >= 1920 && selectedYear <= 2006) {
                        setDoberror(false);
                        setFormData((prevData) => ({
                          ...prevData,
                          date_of_birth: e.target.value,
                        }));
                      } else {
                        setDoberror(true);
                      }
                    }}
                  // onKeyDown={(e) => e.preventDefault()}
                  /> */}

                  <img
                    src="/assets/images/calendar.svg"
                    className="calender_icon"
                    alt=""
                  />
                </div>
                {doberror && (
                  <p style={errorStyle}>
                    {textMapping("Please select a year between 1920 and 2006.")}
                  </p>
                )}
              </div>

              <div className="col-5">
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control input_num input_num_mar"
                    id="floatingAge"
                    placeholder={textMapping("Age")}
                    value={formData.age}
                    readOnly
                  />
                  <label for="floatingAge" className="mobile_label">
                    {textMapping("Age")}
                  </label>
                </div>
              </div>
            </div>

            <div className="gender_grad">
              <h4>{textMapping("Gender")}*</h4>
              <ul className="gender_list">
                <li>
                  <button
                    className={formData.gender === "Female" ? "active" : ""}
                    onClick={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        gender: "Female",
                      }))
                    }
                    disabled={useredit ? true : false}
                  >
                    {textMapping("Female")}
                  </button>
                </li>
                <li>
                  <button
                    className={formData.gender === "Male" ? "active" : ""}
                    onClick={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        gender: "Male",
                      }))
                    }
                    disabled={useredit ? true : false}
                  >
                    {textMapping("Male")}
                  </button>
                </li>
                <li>
                  <button
                    className={formData.gender === "Other" ? "active" : ""}
                    onClick={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        gender: "Other",
                      }))
                    }
                    disabled={useredit ? true : false}
                  >
                    {textMapping("Other")}
                  </button>
                </li>
              </ul>
            </div>

            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control input_num"
                id="email"
                placeholder={textMapping("Email Id")}
                value={formData.email}
                onChange={handleChange}
              />
              <label htmlFor="email" className="mobile_label">
                {textMapping("Email Id")}
              </label>
              {emailCheckError && (
                <p style={errorStyle}>
                  {textMapping("Please enter a valid email address.")}
                </p>
              )}
            </div>
          </div>

          <div className="form_brd">
            <h3 className="addaddress_head">{textMapping("Add address")}</h3>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control input_num"
                id="address"
                placeholder={textMapping("House/ Flat/ Floor No.")}
                value={formData.address}
                onChange={handleChange}
              />
              <label htmlFor="address" className="mobile_label">
                {textMapping("House/ Flat/ Floor No.")}
              </label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="number"
                className="form-control input_num"
                id="pin_code"
                placeholder={textMapping("Current address PIN code")}
                value={formData.pin_code}
                onChange={handleChange}
                readOnly={useredit ? true : false}
              />
              <label htmlFor="pin_code" className="mobile_label">
                {textMapping("Current address PIN code")}
              </label>
              {pincodeError && (
                <p style={errorStyle}>
                  {textMapping("Please enter 6-digit PIN code.")}
                </p>
              )}
            </div>

            <div className="form-floating mb-3">
              <select
                className="form-select form_selct_wight"
                id="state_id"
                aria-label="Floating label select example"
                value={formData.state_id}
                // onChange={handleStateChange}
                disabled={useredit ? true : false}
                onChange={(e) => {
                  handleStateChange(e);
                }}
              >
                <option value="">{textMapping("State")}*</option>
                {filteredStateList
                  ? filteredStateList.length > 0 &&
                    filteredStateList.map((element, index) => {
                      // if (filterstateval && filterstateval.length > 0) {
                      //   if (filterstateval.indexOf(element.name) < 0) {
                      //     return false;
                      //   }
                      // }
                      // if (
                      //   formData["state_id"] &&
                      //   formData["state_id"] != "" &&
                      //   formData["state_id"] != element.id
                      // ) {
                      //   return false;
                      // }
                      return (
                        <option
                          // onClick={() => {
                          //   formData.state_id(element.id);
                          // }}
                          key={element.id}
                          value={element.id}
                          data-name={element.name}
                          nameval={element.name}
                        >
                          {element.name}
                        </option>
                      );
                    })
                  : "No Record Found"}
              </select>
              <label htmlFor="state_id" className="mobile_label mad_col">
                {textMapping("State")}*
              </label>
            </div>

            <div className="form-floating mb-3">
              <select
                className="form-select form_selct_wight"
                id="district"
                aria-label="Floating label select example"
                value={formData.district}
                onChange={handleChange}
                disabled={useredit ? true : false}
              >
                <option value="">{textMapping("District*")}</option>
                {filteredDisttList
                  ? filteredDisttList.length > 0 &&
                    filteredDisttList.map((city, index) => {
                      return (
                        <option
                          value={city.id}
                          data-name={city.name}
                          nameval={city.name}
                        >
                          {city.name}
                        </option>
                      );
                    })
                  : "No Record Found"}
              </select>
              <label htmlFor="district" className="mobile_label mad_col">
                {textMapping("District*")}
              </label>
            </div>

            <div
              className="form_react_select mt-3 mb-3"
              style={{ zIndex: "11" }}
            >
              <div className="form_react_select_pack">
                <label
                  htmlFor="assembly_constituency_id"
                  className="mobile_label mad_col"
                >
                  {textMapping("Assembly constituency (AC)*")}
                </label>

                <Select
                  id="assembly_constituency_id"
                  className="form_selct_wight"
                  key={Math.random()}
                  value={options.find(
                    (option) =>
                      option.value === formData.assembly_constituency_id
                  )}
                  onChange={(selectedOption) => {
                    handleChange({
                      target: {
                        id: "assembly_constituency_id",
                        value: selectedOption ? selectedOption.value : "",
                      },
                    });
                  }}
                  isDisabled={useredit}
                  options={options}
                  placeholder={textMapping("Assembly constituency (AC)*")}
                  isClearable
                  isSearchable
                />
              </div>
            </div>
          </div>
          {!useredit && (
            <>
              <h3 className="addaddress_head">
                Referred by (Only a Primary Member can refer)
              </h3>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control input_num input_num_ref"
                  id="referred_by_number"
                  placeholder={textMapping("Mobile number")}
                  // value={refstatus ? "" : formData.referred_by_number}
                  value={formData.referred_by_number}
                  // onKeyDown={handleKeyDown}
                  onChange={handleChange}
                  // readOnly={refnum ? true : false}
                  readOnly={reff ? true : false}
                />
                <label htmlFor="referred_by_number" className="mobile_label">
                  {textMapping("Mobile number / Referral code")}
                </label>
                {!reff ? (
                  <button
                    style={{
                      top: "50%",
                      right: "-20px",
                      transform: "translate(-50%, -50%)",
                    }}
                    className="val_btn"
                    onClick={() => referralvalid()}
                  >
                    Validate
                  </button>
                ) : (
                  <img
                    src="/assets/images/check.svg"
                    className="val_check_img"
                    alt=""
                  />
                )}

                {mobileCheckError && (
                  <p style={errorStyle}>
                    {textMapping(
                      "Please enter a valid 10-digit mobile number / 6-digit referral code."
                    )}
                  </p>
                )}
              </div>
              {formData.referred_by_name && (
                <div className="mb-3">
                  <h3 className="usernameref">
                    Name : <span>{formData.referred_by_name}</span>
                  </h3>
                </div>
              )}
            </>
          )}
        </div>
        <div className="checkbox_bg">
          <label className="container_check">
            {textMapping(
              "I pledge and willing to receive regular updates from BJP"
            )}
            <input
              type="checkbox"
              // checked="checked"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        <div className="member_container">
          {/* <a
            // to=""
            onClick={(e) => handleSave(e)}
            className={`next_pagebtn ${
              isButtonEnabled ? "" : "next_pagebtn_disable"
            }${isClicked ? "addanimation" : ""}`}
            // className="next_pagebtn next_pagebtn_disable"
          >
            {textMapping("Save")}
            <img src="/assets/images/arrownext.svg" className="" alt="" />
            <img
              src="/assets/images/chevrondisable.svg"
              className="disable_arrow"
              alt=""
            />
          </a> */}

          <div className="menmbarsav_can_flex">
            {useredit && (
              <NavLink
                to={"/refer" + window.location.search}
                className="cancel_form"
              >
                Cancel
              </NavLink>
            )}
            <a
              // to=""
              onClick={(e) => handleSave(e)}
              className={`next_pagebtn ${
                isButtonEnabled ? "" : "next_pagebtn_disable"
              }${isClicked ? "addanimation" : ""}`}
              // className="next_pagebtn next_pagebtn_disable"
            >
              {textMapping("Save")}
              {!useredit && (
                <img src="/assets/images/arrownext.svg" className="" alt="" />
              )}
              <img
                src="/assets/images/chevrondisable.svg"
                className="disable_arrow"
                alt=""
              />
            </a>
          </div>
          <ul className="privacy_list">
            <li>
              <NavLink to="https://www.bjp.org/privacy-policy" target="_blank">
                Privacy policy
              </NavLink>
            </li>
            <li>|</li>
            <li>
              <NavLink to="https://www.bjp.org/disclaimer" target="_blank">
                Disclaimer
              </NavLink>
            </li>
            <li>|</li>
            <li>
              <NavLink to="https://www.bjp.org/contact-us" target="_blank">
                Contact us
              </NavLink>
            </li>
          </ul>
        </div>

        {thankupopup && <Congratulation />}
      </div>
      {showPopup && <TermsPopup popupclose={termclose} />}
      {errorpopup && <ErrorPopup message={message} popupclose={popupclose} />}
      {infopopup && <InfoPopup message={message} popupclose={Infopopupclose} />}
    </>
  );
};

export default UserDetail;
